import { render } from "./ShareIcon.vue?vue&type=template&id=985d1afa"
const script = {}
script.render = render

export default script